
import {defineComponent} from "vue";
import AsideMenu from "@/layout/aside/AsideMenu.vue";

export default defineComponent({
  components: {AsideMenu},
  // type inference enabled
});
